var _regeneratorRuntime = require("/home/trout/static/token-display-app/node_modules/@babel/runtime/regenerator/index.js");

var _asyncToGenerator = require("/home/trout/static/token-display-app/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

var _classCallCheck = require("/home/trout/static/token-display-app/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/home/trout/static/token-display-app/node_modules/@babel/runtime/helpers/createClass.js");

/*
  A library for reading the P2WDB (pay-to-write database)
*/
// Constants that can be customized.
var SERVER = 'https://p2wdb.fullstack.cash'; // const EXPLORER_URL = 'https://explorer.bitcoin.com/bch/tx/'
// Public npm libraries.

var axios = require('axios');

var ReadP2wdb = /*#__PURE__*/function () {
  "use strict";

  function ReadP2wdb() {
    var localConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, ReadP2wdb);

    // Encapsulate dependencies
    this.axios = axios;
    this.serverURL = localConfig.serverURL || SERVER;
  } // Get paginated results.


  _createClass(ReadP2wdb, [{
    key: "getPage",
    value: function () {
      var _getPage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var page,
            options,
            result,
            _args = arguments;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                page = _args.length > 0 && _args[0] !== undefined ? _args[0] : 0;
                options = {
                  method: 'GET',
                  url: "".concat(this.serverURL, "/entry/all/").concat(page),
                  data: {}
                };
                _context.next = 4;
                return this.axios.request(options);

              case 4:
                result = _context.sent;
                return _context.abrupt("return", result.data.data);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getPage() {
        return _getPage.apply(this, arguments);
      }

      return getPage;
    }() // Get a single entry given its hash.

  }, {
    key: "getByHash",
    value: function () {
      var _getByHash = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(hash) {
        var options, result;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                options = {
                  method: 'GET',
                  url: "".concat(this.serverURL, "/entry/hash/").concat(hash)
                };
                _context2.next = 3;
                return this.axios.request(options);

              case 3:
                result = _context2.sent;
                return _context2.abrupt("return", result.data.data);

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getByHash(_x) {
        return _getByHash.apply(this, arguments);
      }

      return getByHash;
    }() // Get an entry by its TXID

  }, {
    key: "getByTxid",
    value: function () {
      var _getByTxid = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(txid) {
        var options, result;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                options = {
                  method: 'GET',
                  url: "".concat(this.serverURL, "/entry/txid/").concat(txid)
                };
                _context3.next = 3;
                return this.axios.request(options);

              case 3:
                result = _context3.sent;
                return _context3.abrupt("return", result.data.data);

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getByTxid(_x2) {
        return _getByTxid.apply(this, arguments);
      }

      return getByTxid;
    }()
  }, {
    key: "getByAppId",
    value: function () {
      var _getByAppId = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(id) {
        var options, result;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                options = {
                  method: 'GET',
                  url: "".concat(this.serverURL, "/entry/appid/").concat(id)
                };
                _context4.next = 3;
                return this.axios.request(options);

              case 3:
                result = _context4.sent;
                return _context4.abrupt("return", result.data.data);

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function getByAppId(_x3) {
        return _getByAppId.apply(this, arguments);
      }

      return getByAppId;
    }()
  }]);

  return ReadP2wdb;
}();

module.exports = ReadP2wdb;